import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/gpt/icons';

export const DailyBonusEventIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M11.92 22.54C16.82 22.54 20.8 18.43 20.8 13.38C20.8 8.33 16.83 4.22 11.92 4.22C7.00999 4.22 3.03999 8.31 3.03999 13.38C3.03999 18.45 7.00999 22.54 11.92 22.54Z"
      fill="url(#paint0_radial_3460_1147)"
    />
    <mask
      id="mask0_3460_1147"
      style={{
        maskType: 'luminance'
      }}
      maskUnits="userSpaceOnUse"
      x={3}
      y={4}
      width={18}
      height={19}>
      <path
        d="M11.92 22.54C16.82 22.54 20.8 18.43 20.8 13.38C20.8 8.33 16.83 4.22 11.92 4.22C7.00999 4.22 3.03999 8.31 3.03999 13.38C3.03999 18.45 7.00999 22.54 11.92 22.54Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3460_1147)">
      <path
        d="M22.02 11.68C22.26 6.84 18.53 2.71 13.7 2.44C8.85999 2.17 4.74999 5.88 4.49999 10.72C4.25999 15.56 7.98999 19.69 12.82 19.96C17.66 20.23 21.77 16.52 22.02 11.68Z"
        fill="url(#paint1_radial_3460_1147)"
      />
    </g>
    <path
      d="M9.02 20.41C8.05 20.37 7.16 20.09 6.34 19.61C6.29 19.58 6.19 19.57 6.13 19.56L5.97 19.84C5.99 19.7 5.61 19.36 5.53 19.2L5.66 19.29L5.63 19.09C5.54 18.99 5.44 18.82 5.34 18.76C5.2 18.66 5.18 18.58 5.1 18.44C4.81 17.94 4.51 17.45 4.26 16.92C4.14 16.66 4.1 16.36 3.94 16.14C3.77 15.89 3.53 15.72 3.41 15.41C3.2 14.84 3.14 14.21 3.09 13.57C3 12.48 3.19 11.31 3.54 10.28C3.81 9.48999 4.14 8.71999 4.67 8.08999C4.14 8.88999 3.71 9.70999 3.48 10.65C3.33 11.24 3.17 11.8 3.15 12.42C3.12 13.45 3.13 14.27 3.42 15.27C3.52 15.6 3.74 15.84 3.97 16.09C4.16 16.29 4.37 16.49 4.61 16.51C4.52 16.45 4.47 16.4 4.44 16.35C4.48 16.32 4.55 16.3 4.55 16.26V16.08L4.64 16.18C4.87 15.61 5 15.11 5.41 14.58C5.46 14.52 5.52 14.46 5.5 14.38C5.27 13.37 5.31 12.08 5.5 11.09C5.22 10.66 4.91 10.25 4.71 9.77999C4.43 9.71999 3.91 10.31 3.71 10.49C3.87 10.22 3.99 9.94999 4.1 9.64999C4.42 8.73999 5.26 7.60999 5.96 6.96999C6.1 6.86999 6.28 6.81999 6.44 6.75999C5.69 7.40999 5.07 8.56999 4.77 9.53999C4.73 9.67999 4.74 9.78999 4.8 9.89999C4.97 10.2 5.15 10.49 5.35 10.79C5.41 10.89 5.48 10.98 5.56 11.05C6.17 10.55 6.82 10.13 7.55 9.86999L8.34 9.58999L8.54 9.20999C8.66 8.99999 8.75 8.75999 8.93 8.58999L8.4 9.57999C8.4 9.57999 8.4 9.70999 8.42 9.73999C8.96 10.52 9.47 11.33 9.97 12.14C10.07 12.3 10.13 12.28 10.3 12.28L10.94 12.25C11.58 12.22 12.24 12.23 12.88 12.25C13.09 12.25 13.29 12.27 13.5 12.25C14.03 11.32 14.61 10.46 15.23 9.60999L15.17 9.37999C15.25 9.46999 15.28 9.58999 15.38 9.61999C16.36 9.86999 17.37 10.25 18.19 10.9C18.5 10.56 18.74 10.14 18.93 9.70999C18.98 9.59999 19.07 9.46999 19.03 9.34999C18.71 8.22999 18.09 7.27999 17.24 6.53999L17.34 6.42999C18.14 7.18999 18.72 7.74999 19.29 8.70999C19.49 9.04999 19.64 9.40999 19.81 9.76999C19.97 10.11 20.11 10.11 20.23 10.38C19.89 10.03 19.83 9.84999 19.39 9.58999C19.29 9.52999 19.14 9.47999 19.05 9.53999C18.85 10.03 18.63 10.47 18.29 10.87C18.26 10.9 18.24 11 18.25 11.04C18.58 12.21 18.58 13.03 18.46 14.23C19.06 15.02 19.17 15.4 19.44 16.38C19.89 16.17 20.34 15.82 20.53 15.34C20.81 14.64 20.81 13.38 20.78 12.61C20.75 11.9 20.59 11.25 20.37 10.58C20.28 10.32 20.22 10.08 20.11 9.81999C19.82 9.10999 19.44 8.49999 19.02 7.86999C19.43 8.30999 19.69 8.83999 19.95 9.36999C20.41 10.3 20.79 11.68 20.84 12.73C20.89 13.72 20.82 14.45 20.59 15.41C20.34 16.45 20.14 17.17 19.61 18.09C19.33 18.56 19.03 19.01 18.68 19.42C18.43 19.7 17.92 20.25 17.66 20.48C16.83 21.23 15.9 21.79 14.85 22.14C14.26 22.33 13.69 22.48 13.07 22.54L12.63 22.57H12.24C9.73 22.68 7.48 21.71 5.7 19.87C4.99 19.13 4.4 18.3 3.98 17.35C3.77 16.87 3.6 16.41 3.49 15.89C3.46 15.75 3.39 15.63 3.41 15.48C3.5 15.73 3.55 15.95 3.61 16.19C3.88 17.18 4.26 17.92 4.82 18.74C5.11 19.18 5.44 19.53 5.81 19.91C6.67 20.81 7.66 21.48 8.79 21.94C9.44 22.21 10.11 22.4 10.81 22.48L11.33 22.53C11.54 22.55 11.76 22.55 11.98 22.52C11.82 22.52 11.82 21.72 11.82 21.72C10.82 21.51 9.89 21.1 9.04 20.46H9.03L9.02 20.41ZM8.76 11.36C8.88 11.39 8.86 11.53 8.85 11.61C8.84 11.75 9 11.81 9.1 11.81C9.1 11.82 9.12 11.9 9.13 11.9L9.21 11.86L9.32 12.06L9.3 11.81L9.51 12.2L9.17 12.96C9.3 12.94 9.21 12.79 9.34 12.78L9.22 13.03C9.27 12.98 9.33 12.93 9.35 12.89L9.78 12.17C9.38 11.41 8.94 10.69 8.42 10.02C8.36 9.92999 8.23 9.80999 8.13 9.78999C7.85 9.83999 7.63 9.91999 7.38 10.02L7.48 10.06L7.24 10.19C7.51 10.17 7.7 10.03 7.95 10.06C8.14 10.08 8.3 10.29 8.39 10.44C8.37 10.46 8.33 10.48 8.34 10.46C8.34 10.46 8.34 10.41 8.33 10.4L8.27 10.32C8.27 10.32 8.19 10.35 8.21 10.37C8.22 10.4 8.26 10.46 8.25 10.48L8.21 10.62L8.33 10.49C8.25 10.67 8.27 10.78 8.36 10.93C8.55 11.24 8.94 11.09 8.94 11.25C8.88 11.23 8.8 11.2 8.73 11.2C8.7 11.2 8.64 11.3 8.67 11.32C8.69 11.34 8.72 11.34 8.78 11.36H8.8H8.76ZM14.42 11.37C14.45 11.52 14.46 11.62 14.55 11.66C14.64 11.7 14.74 11.66 14.8 11.61C14.89 11.52 14.9 11.4 14.82 11.32C14.67 11.21 14.57 11.32 14.4 11.41C14.66 11 14.89 10.59 15.22 10.25C15.49 9.96999 15.92 10.04 16.26 10.1C16 9.93999 15.7 9.82999 15.37 9.80999C15.26 9.88999 15.13 9.98999 15.05 10.11C14.52 10.75 14.08 11.43 13.69 12.18C13.75 12.34 13.83 12.48 13.93 12.62C13.91 12.15 14.2 11.76 14.43 11.38L14.42 11.37ZM8.39 20.28L8.93 20.33L10.07 18.24C9.82 17.85 9.47 17.56 9.29 17.12L9.76 17.76L10.04 18.09C10.15 18.11 10.25 18.12 10.37 18.13C11.43 18.18 12.47 18.17 13.55 18.05C14.19 17.19 14.72 16.24 15.17 15.23L14.48 14.04L13.4 12.25C13.22 12.21 13.06 12.21 12.87 12.21C12.72 12.21 12.58 12.2 12.43 12.19C12.1 12.18 11.76 12.19 11.44 12.19L10.38 12.22C10.27 12.22 10.18 12.24 10.06 12.25C9.46 13.23 8.9 14.2 8.34 15.23C8.6 15.9 8.94 16.49 9.27 17.11C8.96 16.71 8.75 16.26 8.54 15.81L8.26 15.25C7.29 15.07 6.39 14.83 5.5 14.39C5.01 15.02 4.78 15.65 4.6 16.42C4.81 17.47 5.48 18.65 6.22 19.37C6.65 19.79 7.78 20.17 8.38 20.24V20.26L8.39 20.28ZM14.67 20.27C15.28 20.25 15.78 20.11 16.33 19.95C16.85 19.76 17.37 19.54 17.78 19.15C18.58 18.4 19.1 17.38 19.34 16.31C19.17 15.52 18.89 14.83 18.41 14.22C17.94 14.53 17.45 14.74 16.95 14.91C16.41 15.07 15.9 15.18 15.35 15.27C15.29 15.28 15.2 15.32 15.17 15.39L14.79 16.14C14.45 16.83 14.06 17.46 13.6 18.08L14.67 20.27ZM18.43 19.13C18.34 19.28 18.27 19.42 18.15 19.56L18.18 19.8C18.94 19.07 19.51 18.2 19.94 17.24C20.2 16.66 20.35 16.06 20.5 15.45C20.35 15.64 20.24 15.78 20.08 15.93C19.87 16.66 19.59 17.37 19.2 18.02L18.97 18.41C18.97 18.41 18.5 19 18.41 19.14H18.42L18.43 19.13ZM12.34 18.49C12.65 18.48 12.9 18.45 13.18 18.39H12.76L13.28 18.29L12 18.34C11.45 18.36 10.93 18.34 10.38 18.32C10.34 18.32 10.23 18.37 10.22 18.42C10.21 18.46 10.22 18.56 10.24 18.6C10.26 18.57 10.3 18.5 10.34 18.51H11.03C10.98 18.59 12.12 18.51 12.36 18.5V18.48L12.34 18.49ZM12.76 22.46C13.92 22.38 15.06 22.03 16.07 21.48C16.82 21.07 17.55 20.49 18.13 19.85C18.11 19.65 18.1 19.45 18.01 19.27C17.98 19.18 17.86 19.19 17.78 19.24C17.08 19.72 16.32 20.1 15.48 20.23L14.55 20.37C13.76 21 12.85 21.42 11.87 21.64C11.87 21.89 11.91 22.11 11.99 22.33C12.04 22.47 12.15 22.51 12.29 22.5L12.75 22.47H12.76V22.46Z"
      fill="black"
    />
    <path
      d="M17.26 6.22C16.47 5.54 15.56 5.07 14.61 4.73C14.02 4.52 13.43 4.4 12.81 4.3C12.4 4.25 11.68 4.26 11.25 4.27C10.42 4.29 8.69001 4.79 7.96001 5.2L6.99001 5.75C8.07001 4.91 9.88001 4.33 11.21 4.24L11.51 4.22C11.74 4.21 11.96 4.2 12.19 4.22L12.61 4.25C14.2 4.38 15.71 4.99 17.01 5.96C17.13 6.06 17.24 6.14 17.35 6.23C17.73 6.48 18.07 6.76 18.38 7.09C18.42 7.13 18.49 7.15 18.5 7.24C18.35 7.13 18.22 6.99 18.08 6.85C17.89 6.67 17.67 6.5 17.45 6.35C17.4 6.32 17.34 6.3 17.28 6.23H17.27L17.26 6.22Z"
      fill="black"
    />
    <path
      d="M13.34 6.81C12.34 6.65 11.35 6.63 10.37 6.83C10.2 6.86 10.07 6.95 9.95 7.07L10.07 6.89C9.66 6.43 9.23 6.02 8.73 5.67C8.84 5.51 8.98 5.4 9.14 5.31C9.88 4.85 10.69 4.57 11.54 4.46C11.73 4.44 11.92 4.42 12.11 4.44C12.98 4.56 14.1 4.88 14.81 5.46L14.47 5.75C14.07 6.08 13.7 6.43 13.35 6.84V6.82L13.34 6.81ZM12.43 6.47C12.38 6.44 12.33 6.43 12.28 6.41L12.99 6.39L12.53 6.36C11.97 6.32 11.44 6.31 10.87 6.35C10.18 6.39 10.26 6.26 9.73 5.85L9.86 6.09C9.86 6.09 9.8 6.18 9.77 6.17L9.54 6.03L9.97 6.47C10.05 6.55 10.12 6.64 10.22 6.67C10.97 6.53 11.68 6.49 12.43 6.5V6.47Z"
      fill="black"
    />
    <path
      d="M8.76 11.36C8.71 11.35 8.66 11.34 8.65 11.32C8.63 11.3 8.68 11.2 8.71 11.2C8.77 11.2 8.85 11.22 8.92 11.25C8.92 11.09 8.52 11.24 8.34 10.93C8.24 10.77 8.24 10.67 8.31 10.49L8.19 10.62L8.23 10.48C8.23 10.48 8.2 10.42 8.19 10.37C8.19 10.35 8.24 10.31 8.25 10.32L8.31 10.4C8.31 10.4 8.33 10.45 8.32 10.46C8.32 10.47 8.35 10.46 8.37 10.44C8.27 10.29 8.11 10.1 7.93 10.06C7.68 10.03 7.49 10.17 7.22 10.19L7.46 10.06L7.36 10.02C7.61 9.91999 7.83 9.84999 8.11 9.78999C8.2 9.79999 8.32 9.92999 8.4 10.02C8.93 10.7 9.37 11.4 9.76 12.17L9.33 12.89C9.33 12.89 9.25 12.99 9.2 13.03L9.32 12.78C9.18 12.78 9.28 12.94 9.15 12.96L9.49 12.2L9.28 11.81L9.3 12.06L9.19 11.86L9.11 11.9C9.11 11.9 9.09 11.84 9.08 11.81C8.98 11.81 8.81 11.76 8.82 11.61C8.82 11.52 8.85 11.4 8.73 11.36H8.72H8.76Z"
      fill="white"
    />
    <path
      d="M14.42 11.37C14.18 11.75 13.89 12.13 13.92 12.61C13.83 12.47 13.75 12.33 13.68 12.17C14.08 11.42 14.52 10.74 15.04 10.1C15.13 9.99 15.25 9.87 15.36 9.8C15.69 9.82 15.99 9.92 16.25 10.09C15.91 10.03 15.48 9.96 15.21 10.24C14.89 10.57 14.66 10.99 14.39 11.4C14.55 11.31 14.65 11.2 14.81 11.31C14.9 11.4 14.89 11.51 14.79 11.6C14.73 11.66 14.62 11.7 14.54 11.65C14.45 11.61 14.44 11.51 14.41 11.36L14.42 11.37Z"
      fill="white"
    />
    <path
      d="M12.34 18.49C12.1 18.49 10.96 18.58 11.01 18.5H10.32C10.32 18.5 10.24 18.56 10.22 18.59C10.21 18.55 10.19 18.46 10.2 18.41C10.21 18.37 10.32 18.31 10.36 18.31C10.91 18.32 11.43 18.35 11.98 18.33L13.26 18.28L12.74 18.39H13.16C12.88 18.44 12.63 18.48 12.32 18.49H12.33H12.34Z"
      fill="white"
    />
    <path
      d="M12.43 6.47001C11.68 6.47001 10.97 6.50001 10.22 6.64001C10.13 6.61001 10.05 6.51001 9.96999 6.44001L9.53999 6.00001L9.76999 6.14001C9.76999 6.14001 9.86999 6.09001 9.85999 6.06001L9.72999 5.82001C10.26 6.23001 10.18 6.37001 10.87 6.32001C11.43 6.28001 11.98 6.29001 12.53 6.33001L12.99 6.36001L12.28 6.38001C12.33 6.40001 12.38 6.41001 12.43 6.44001V6.47001Z"
      fill="white"
    />
    <path
      d="M13.34 22.35C13.06 22.4 12.8 22.44 12.51 22.44C12.53 22.39 12.54 22.32 12.57 22.32H12.71L13.04 22.28L12.94 22.33C13.09 22.31 13.21 22.3 13.33 22.35H13.34Z"
      fill="black"
    />
    <path
      opacity={0.5}
      d="M6.02 20.42C7.17 21.28 9.23 22.06 9.23 22.06C8.9 21.2 6.57 19.83 6.79 13.64C7.46 8.53 12.89 6.29 12.89 6.29C12.89 6.29 12.8 5.72 11.93 5.47C11.6 5.37 6.32 5.62 4.62 10.35C4.32 11.03 3.92 12.58 4.26 15.05C4.52 17.88 5.77 20.38 6.03 20.42H6.02Z"
      fill="black"
    />
    <path
      d="M5.79 20.42C6.94 21.28 9 22.06 9 22.06C8.67 21.2 6.34 19.83 6.56 13.64C7.23 8.53 12.66 6.29 12.66 6.29C12.66 6.29 12.57 5.72 11.7 5.47C11.37 5.37 6.09 5.62 4.39 10.35C4.09 11.03 3.69 12.58 4.03 15.05C4.29 17.88 5.54 20.38 5.8 20.42H5.79Z"
      fill="url(#paint2_linear_3460_1147)"
    />
    <path
      opacity={0.25}
      d="M13.9 22.42C13.9 22.42 14.75 21.99 16.59 21.36C18.8 19.84 19.82 17.08 19.82 14.11C19.82 11.14 18.97 9.35 17.17 7.37C15.84 5.95 12.91 5.4 11.73 5.67C11.53 5.66 10.56 5.8 10.29 6.01C10.01 6.22 13.68 6.42 15.84 9.65C17.71 12.12 17.51 16.68 16.77 18.54C15.74 20.73 14.56 21.53 13.86 22.24C13.51 22.6 13.89 22.42 13.89 22.42H13.9Z"
      fill="#020202"
    />
    <path
      d="M14.1 22.39C14.1 22.39 14.95 21.96 16.79 21.33C19 19.81 20.02 17.05 20.02 14.08C20.02 11.11 19.17 9.32 17.37 7.34C16.04 5.92 13.11 5.37 11.93 5.64C11.73 5.63 10.76 5.77 10.49 5.98C10.21 6.19 13.88 6.39 16.04 9.62C17.91 12.09 17.71 16.65 16.97 18.51C15.94 20.7 14.76 21.5 14.06 22.21C13.71 22.57 14.09 22.39 14.09 22.39H14.1Z"
      fill="url(#paint3_linear_3460_1147)"
    />
    <path
      d="M11.21 5.93999C10.6 5.76999 6.85001 4.70999 6.85001 4.70999L5.74001 4.94999C5.74001 4.94999 5.90001 4.45999 6.03001 4.38999C6.16001 4.32999 8.87001 3.70999 9.37001 3.81999C9.86001 3.92999 12.44 5.69999 12.44 5.69999L11.21 5.93999Z"
      fill="url(#paint4_linear_3460_1147)"
    />
    <path
      d="M17.74 5.25C17.74 5.25 17.74 5.01 17.65 4.86C17.57 4.72 15.19 4.03 14.96 4.02C14.72 4 11 5.44 11 5.44C11 5.44 11.61 5.71 12.03 5.77C12.45 5.83 17.06 5.02 17.16 5.02C17.26 5.02 17.74 5.26 17.74 5.26V5.25Z"
      fill="url(#paint5_linear_3460_1147)"
    />
    <path
      opacity={0.74}
      d="M12.01 6.33C12.01 6.33 15.09 6.63 17.02 6.37C18.95 6.11 17.91 5.31 17.91 5.31L11.5 6.09L12 6.33H12.01Z"
      fill="#27213A"
    />
    <path
      d="M12.3 5.93999C12.3 5.93999 12.26 5.93999 12.19 5.95999C12.17 5.95999 12.14 5.97999 12.09 5.98999C11.38 6.27999 9.02001 7.49999 8.61001 7.58999C8.51001 7.60999 8.30001 7.58 8.02001 7.50999C6.94001 7.27 4.88001 6.54999 4.73001 6.37999C4.54001 6.14999 2.89001 1.93999 4.91001 1.42999C6.17001 1.11999 7.89001 2.62999 9.21001 3.77999C10.01 4.47999 10.67 5.05999 10.99 5.01999C10.99 5.01999 11.48 5.34999 11.86 5.60999C11.92 5.64999 11.98 5.69999 12.03 5.73999C12.11 5.78999 12.18 5.83999 12.22 5.87999C12.26 5.91 12.28 5.92999 12.28 5.92999L12.3 5.93999Z"
      fill="url(#paint6_linear_3460_1147)"
    />
    <path
      opacity={0.5}
      d="M8.60001 7.32C7.90001 7.59 7.44001 3.94 7.58001 3.35C7.71001 2.76 10.01 5.74 11.43 5.76C12.85 5.78 8.75001 7.25 8.60001 7.32Z"
      fill="#450045"
    />
    <path
      opacity={0.74}
      d="M12.3 5.78L12.24 5.88V5.9L12.19 5.95L12.09 5.98C11.38 6.27 9.02 7.49 8.61 7.58C8.51 7.6 8.3 7.57 8.02 7.5C7.52 6.46 6.37 2.04 7.94 3.04C8.33 3.29 8.77 3.53 9.21 3.78C10.01 4.48 10.67 5.06 10.99 5.02C10.99 5.02 11.48 5.35 11.86 5.61C11.63 5.37 11.52 5.12 11.5 5.06C11.82 5.26 12.06 5.44 12.19 5.59C12.25 5.65 12.29 5.72 12.3 5.77H12.31L12.3 5.78Z"
      fill="#2E001E"
    />
    <path
      d="M17.58 5.51C17.16 5.95 12.82 6.16 12.29 5.99C12.25 5.98 12.2 5.96 12.17 5.94C12.17 5.94 12.13 5.92 12.12 5.91C12.07 5.88 12.01 5.83 11.97 5.79C11.92 5.75 11.87 5.69 11.83 5.65C11.65 5.44 11.55 5.2 11.53 5.15C11.92 5.15 13.44 0.810003 13.96 0.360003C14.44 -0.0699968 17.74 0.0900032 19.07 0.720003C19.22 0.780003 19.33 0.860003 19.41 0.950003C20.3 1.79 18.04 5.06 17.61 5.52H17.59L17.58 5.51Z"
      fill="url(#paint7_linear_3460_1147)"
    />
    <path
      opacity={0.5}
      d="M12.29 5.73C12.29 5.73 13.82 5.31 15.12 4.66C17.05 3.67 17.99 1.63 18.79 1.54C19.63 1.44 18.36 4.95 16.83 5.44C15.42 5.87 12.29 5.74 12.29 5.74V5.73Z"
      fill="#20041F"
    />
    <path
      opacity={0.74}
      d="M17.58 5.51C17.16 5.95 12.82 6.16 12.29 5.99C12.25 5.98 12.2 5.96 12.17 5.94C12.17 5.94 12.13 5.94 12.08 5.96L12.02 6.06L12 6L11.96 5.81V5.78C11.96 5.78 12.02 5.69 12.09 5.64C12.61 5.29 14.55 4.88 15.79 3.67C17.42 2.08 17.96 0.889996 19.03 0.729996C19.18 0.789996 19.29 0.869996 19.37 0.959996C20.26 1.8 18 5.07 17.57 5.53H17.58V5.51Z"
      fill="#2D071F"
    />
    <path
      d="M10.79 4.98C10.79 4.98 11.99 4.67 12.7 4.98C13.41 5.29 13.25 5.83 13.17 6.06C13.09 6.3 11.68 6.18 11.68 6.18C11.68 6.18 11.77 5.91 11.65 5.51C11.53 5.12 10.8 4.97 10.8 4.97H10.79V4.98Z"
      fill="url(#paint8_linear_3460_1147)"
    />
    <path
      opacity={0.74}
      d="M11.96 4.92C11.96 4.92 12.75 3.2 13.41 1.9C14.12 0.490002 16.66 1.13 16.62 2.24C16.57 3.31 13.53 4.93 13.07 5.01C12.62 5.07 11.96 4.91 11.96 4.91V4.92Z"
      fill="#FF5CC5"
      fillOpacity={0.4}
    />
    <path
      opacity={0.74}
      d="M12.44 5.01C12.44 5.01 13.21 4.84 13.62 4.33C14.04 3.8 13.81 2.16 13.51 2.23C13.21 2.29 11.95 4.92 11.95 4.92L12.43 5.01H12.44Z"
      fill="#FF5CC5"
    />
    <path
      opacity={0.3}
      d="M4.24 1.87C4.08 2.17 6.01 2.18 6.47 2.83C6.92 3.46 7.19 2.89 7.55 2.83C7.91 2.77 6.22 1.62 5.31 1.6C4.4 1.58 4.25 1.88 4.25 1.88H4.24V1.87Z"
      fill="white"
    />
    <path
      opacity={0.3}
      d="M13.63 0.959993C13.48 1.20999 15.21 0.699993 16.07 1.11999C16.95 1.55999 17.75 1.17999 18.1 0.849993C18.44 0.509993 14.38 -0.260007 13.64 0.959993H13.63Z"
      fill="white"
    />
    <path
      opacity={0.74}
      d="M16.56 3.59C15.77 4.41 17.02 5.31 17.25 5.24C17.48 5.18 19.11 3.2 18.92 2.08C18.74 0.929996 18.01 2.09 16.56 3.58V3.59Z"
      fill="#2D001D"
    />
    <path
      opacity={0.74}
      d="M7.73 5.43999C7.79 5.74999 10.81 5.82999 11 5.77999C11.19 5.73999 9.68 5.06999 8.81 4.15999C7.94 3.24999 7.64 3.22999 7.57 3.36999C7.49 3.49999 7.68 5.20999 7.73 5.43999Z"
      fill="#2A001B"
    />
    <path
      opacity={0.5}
      d="M12.44 23.89C16.33 23.89 19.48 23.66 19.48 23.37C19.48 23.08 16.33 22.85 12.44 22.85C8.54999 22.85 5.39999 23.08 5.39999 23.37C5.39999 23.66 8.54999 23.89 12.44 23.89Z"
      fill="black"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3460_1147"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.2737 13.3156) scale(6.6554 6.9764)">
        <stop stopColor="white" />
        <stop offset={1} stopColor="#9E7DCB" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_3460_1147"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(16.5816 0.906737 -0.889439 17.8578 14.6552 8.13493)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset={1} stopColor="#BC8CFF" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_3460_1147"
        x1={8.28}
        y1={18.83}
        x2={8.28}
        y2={5.31}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#0000A9" />
        <stop offset={1} stopColor="#C400FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3460_1147"
        x1={15.25}
        y1={18.93}
        x2={15.25}
        y2={5.31}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#8700A9" />
        <stop offset={1} stopColor="#FF00A6" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3460_1147"
        x1={9.09001}
        y1={5.93999}
        x2={9.09001}
        y2={3.79999}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#342EE8" />
        <stop offset={1} stopColor="#F95FC7" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3460_1147"
        x1={14.37}
        y1={5.78}
        x2={14.37}
        y2={4.03}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#E82E86" />
        <stop offset={1} stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3460_1147"
        x1={8.11001}
        y1={7.58999}
        x2={8.11001}
        y2={1.39999}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#6300A9" />
        <stop offset={1} stopColor="#F200FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3460_1147"
        x1={15.57}
        y1={6.05}
        x2={15.57}
        y2={0.120003}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#9201A9" />
        <stop offset={1} stopColor="#EB01A6" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3460_1147"
        x1={12.02}
        y1={6.21}
        x2={12.02}
        y2={4.85}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#8D00A8" />
        <stop offset={1} stopColor="#F001A6" />
      </linearGradient>
    </defs>
  </svg>
);
